import React, { useState } from 'react'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Dialog from '@material-ui/core/Dialog'
import Button from '@material-ui/core/Button'
import { injectIntl } from 'react-intl'
import { PHOTO_VALID } from 'constants/index'
import { ReactComponent as AvatarPlaceholderIcon } from 'assets/img/avatar-placeholder.svg'
import messages from './translate'

function ChangeAvatarDialog({
  intl: { formatMessage },
  isOpenChangeAvatar,
  onCloseChangeAvatar,
  updatePhoto,
}) {
  const [image, setImage] = useState({
    file: null,
    content: null,
  })
  const isImage = !image.file

  const onChange = e => {
    const file = e.target.files[0]
    const fr = new FileReader()
    fr.onload = () =>
      setImage({
        file,
        content: fr.result,
      })
    fr.readAsDataURL(e.target.files[0])
  }

  const onClose = () => {
    setImage({
      file: null,
      content: null,
    })
    onCloseChangeAvatar()
  }

  const onSave = () => {
    const { file: avatar } = image

    if (!avatar) {
      console.log('ERROOR FILE EMPTY')

      return
    }

    const { size, type } = avatar
    const { fileSize, fileType } = PHOTO_VALID
    const isTypeValid = fileType.some(x => x === type)

    if (size <= fileSize && isTypeValid) {
      updatePhoto(avatar)
      onClose()
    } else {
      console.log('ERROOR', size <= fileSize, isTypeValid)
    }
  }

  return (
    <Dialog
      open={isOpenChangeAvatar}
      onClose={onClose}
      className="change-avatar-dialog"
      aria-labelledby="form-dialog-title">
      <DialogContent>
        <div className="close-button" onClick={onClose} />
        <div className="avatar">
          <label htmlFor="contained-button-file">
            {image.content ? (
              <img src={image.content} alt="Avatar" />
            ) : (
              <AvatarPlaceholderIcon />
            )}
          </label>
          <input
            id="contained-button-file"
            type="file"
            accept="image/*"
            onChange={onChange}
            style={{ display: 'none' }}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          className="profile-page-button"
          disabled={isImage}
          onClick={onSave}>
          {formatMessage(messages.save)}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default injectIntl(ChangeAvatarDialog)
